import $ from 'jquery';
import React, { useState } from 'react';
import Cookies from 'js-cookie';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles(theme => ({
  paper: {
    margin: theme.spacing(1, 4, 8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(1)
    },
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(1, 4, 8, 4)
    }
  },
  avatar: {
    margin: theme.spacing(1),
    width: theme.spacing(10),
    height: theme.spacing(10),
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(4),
      height: theme.spacing(4)
    },
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(8),
      height: theme.spacing(8)
    }
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
    padding: theme.spacing(1, 0),
    fontSize: '22px',
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0)
    },
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(3, 0, 1)
    }
  },
  socialsInfo: {
    margin: '10px auto',
    textAlign: 'center',
    color: '#48484a',
    padding: theme.spacing(0, 10),
    fontSize: '1.1em',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 8)
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 0)
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 0)
    },
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(0, 0)
    }
  },
  socialSubmit: {
    width: '100%',
    fontSize: 14,
    padding: theme.spacing(1.3, 3),
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: 2,
    border: '1px solid transparent',
    boxShadow:
      'rgb(0 0 0 / 24%) 0px 2px 2px 0px, rgb(0 0 0 / 24%) 0px 0px 1px 0px',
    textTransform: 'none',
    '&:hover': {
      color: 'rgba(0, 0, 0, 0.54)',
      backgroundColor: 'rgb(255, 255, 255)'
    }
  },
  facebookSubmit: {
    backgroundColor: '#1877f2',
    color: '#ffffff',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#1877f2'
    }
  },
  sizeAvatar: {
    height: theme.spacing(2.5),
    width: theme.spacing(2.5)
  },
  facebookAvatar: {
    height: theme.spacing(4.2),
    width: theme.spacing(4.2)
  },
  progressBar: {
    margin: 'auto',
    position: 'absolute',
    top: '50%'
  },
  socialGrid: {
    margin: theme.spacing(1)
  },
  title: {
    fontWeight: 'bold',
    margin: theme.spacing(1, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: '16px'
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '2.125rem'
    }
  },
  titleSub: {
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  },
  signUpButton: {
    cursor: 'pointer',
    paddingLeft: '0px',
    color: '#3f9673',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '16px'
    }
  },
  signInTypog: {
    [theme.breakpoints.down('md')]: {
      fontSize: '16px'
    }
  }
}));

export default function Signin(props) {
  const { changeMode, qtWindow } = props;
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    $.ajax({
      url: '/user_account/login/',
      data: $('form').serialize(),
      method: 'POST',
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      success() {
        window.location.reload();
      },
      error(xhr) {
        let error = {};
        if (xhr.readyState === 4) {
          error = JSON.parse(xhr.responseText);
        } else if (xhr.readyState === 0) {
          error = { common_error: 'Connection error.' };
        } else {
          error = { common_error: 'Something went wrong.' };
        }
        setErrors(error);
        setLoading(false);
      }
    });
  }

  if (loading)
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress className={classes.progressBar} />
      </div>
    );

  return (
    <div className={classes.paper}>
      <Avatar
        alt="chessify logo"
        variant="rounded"
        src={
          navigator.userAgent.toLowerCase().indexOf('safari') !== -1 &&
            navigator.userAgent.toLowerCase().indexOf('chrome') <= -1
            ? '/dg_static/website/images/chessify_icon.jpg'
            : '/dg_static/website/images/chessify_icon.webp'
        }
        className={classes.avatar}
      />
      <Typography component="h1" variant="h3" className={classes.title}>
        Welcome Back!
      </Typography>
      <Typography component="h1" variant="h5" className={classes.titleSub}>
        New to Chessify?{' '}
        <Button
          onClick={() => changeMode('signup')}
          className={classes.signUpButton}
          disableFocusRipple
        >
          <Typography
            component="h1"
            variant="h5"
            className={classes.signInTypog}
          >
            Sign Up
          </Typography>
        </Button>
      </Typography>
      <form className={classes.form} noValidate onSubmit={handleSubmit}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="username"
          label="Username"
          name="username"
          autoFocus
          error={Boolean(errors.username) || Boolean(errors.non_field_errors)}
          helperText={errors.username}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
          error={Boolean(errors.password) || Boolean(errors.non_field_errors)}
          helperText={errors.password}
        />
        <Typography color="error">
          {errors.non_field_errors
            ? errors.non_field_errors
            : errors.common_error}
        </Typography>
        <Grid container>
          <Grid item>
            <Typography
              variant="h6"
              style={{ cursor: 'pointer', marginTop: '8px', fontSize: '16px' }}
              onClick={() => changeMode('reset')}
            >
              {'Forgot password?'}
            </Typography>
          </Grid>
        </Grid>
        <Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
        </Grid>
        <div className={classes.socialsInfo}>
          <Typography variant="body">
            Sign in with your social media account or email address
          </Typography>
        </div>
        <Grid
          container
          spacing={1}
          alignItems="center"
          style={{ marginTop: '15px' }}
        >
          <Grid item xs={12} md={6}>
            <Button
              startIcon={
                <Avatar
                  alt="google"
                  variant="rounded"
                  className={classes.sizeAvatar}
                  src="/dg_static/website/images/google.png"
                />
              }
              type="submit"
              variant="contained"
              className={classes.socialSubmit}
              href="/accounts/google/login/?process=login"
            >
              <span style={{ marginRight: 17 }}>Continue with Google</span>
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              startIcon={
                <Avatar
                  alt="facebook"
                  variant="rounded"
                  className={classes.sizeAvatar}
                  src="/dg_static/website/images/reverse_fb_logo.png"
                />
              }
              type="submit"
              variant="contained"
              className={`${classes.socialSubmit} ${classes.facebookSubmit}`}
              href="/accounts/facebook/login/?process=login"
            >
              Continue with Facebook
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
